export const DIAGNOSTIC_EVENTS = new Set([
  "dialog-connect:start",
  "dialog-connect:joined",
  "dialog-connect:join-error",
  "dialog-connect:closed-before-open",
  "protoo:open",
  "protoo:close",
  "protoo:disconnected",
  "protoo:failed",
  "protoo-request:timeout",
  "protoo-request:responsive",
  "recovery:attempt",
  "signaling:rpc",
  "ice-restart:start",
  "ice-restart:done",
  "ice-restart:send-error",
  "ice-restart:recv-error",
  "transport:send-state",
  "transport:recv-state",
  "recovery:start",
  "recovery:state",
  "recovery:connected",
  "recovery:done",
  "recovery:error",
  "recovery:unexpected-close-error",
  "admission:result",
  "room:leave"
]);
const STATES = new Set([
  "new",
  "connecting",
  "connected",
  "disconnected",
  "failed",
  "closed",
  "reconnecting",
  "reallocating",
  "unavailable"
]);
const CODES = new Set([
  "pending_session_missing",
  "admission_denied",
  "signaling_timeout",
  "transport_closed",
  "auth_error",
  "unknown"
]);
export const DIAGNOSTIC_RPC_METHODS = new Set([
  "refreshAuthToken",
  "restartIce",
  "getRouterRtpCapabilities",
  "createWebRtcTransport",
  "connectWebRtcTransport",
  "join",
  "produce",
  "sendChatMessage",
  "sendPrivateChatMessage",
  "setRoomMediaQuality",
  "moderatePeerMedia",
  "refreshConsumers",
  "closeWebRtcTransport",
  "closeProducer"
]);
export const DIAGNOSTIC_STAGES = new Set([
  "admission",
  "allocation",
  "socket",
  "router-capabilities",
  "device-load",
  "send-transport",
  "receive-transport",
  "join",
  "local-media",
  "signaling-probe"
]);
const IDS = ["roomId", "clientId", "peerId", "allocationId", "correlationId", "transportId"];
export const safeId = value => typeof value === "string" && /^[A-Za-z0-9_-]{1,64}$/.test(value);
export const diagnosticBytes = value => new TextEncoder().encode(JSON.stringify(value)).length;

export function sanitizeDiagnosticEvent(event, details = {}) {
  try {
    if (!DIAGNOSTIC_EVENTS.has(event)) return null;
    const data = {};
    for (const key of IDS) {
      const value = details?.[key];
      if (safeId(value)) data[key] = value;
    }
    for (const key of ["protooConnected", "dialogJoined", "canEnter"]) {
      const value = details?.[key];
      if (typeof value === "boolean") data[key] = value;
    }
    const state = details?.state,
      code = details?.code,
      role = details?.transportRole;
    if (DIAGNOSTIC_RPC_METHODS.has(details?.rpcMethod)) data.rpcMethod = details.rpcMethod;
    if (DIAGNOSTIC_STAGES.has(details?.stage)) data.stage = details.stage;
    if (STATES.has(state)) data.state = state;
    if (CODES.has(code)) data.code = code;
    if (["send", "receive"].includes(role)) data.transportRole = role;
    for (const [key, min, max] of [
      ["status", 100, 599],
      ["durationMs", 0, 86400000],
      ["timeoutMs", 0, 120000],
      ["timerLagMs", 0, 60000],
      ["connectionAttempt", 1, 1000000]
    ]) {
      const value = details?.[key];
      if (Number.isInteger(value) && value >= min && value <= max) data[key] = value;
    }
    return data;
  } catch (_) {
    return {};
  }
}
